import { render, staticRenderFns } from "./MachineRecord.vue?vue&type=template&id=cb8ecca4&scoped=true"
import script from "./MachineRecord.vue?vue&type=script&lang=js"
export * from "./MachineRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8ecca4",
  null
  
)

export default component.exports